// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".bidCard {\n  display: flex;\n  justify-content: space-between;\n  align-items: start;\n  padding: 0 2rem;\n  color: #333333;\n  margin-bottom: 15px;\n}\n\n.leftWing {\n  width: 65%;\n  margin: 2rem 0;\n}\n.rightWing {\n  width: 30%;\n  margin: 2rem 0;\n}\n\n@media (max-width: 1100px) {\n  .bidCard {\n    flex-wrap: wrap;\n    padding: 1 rem;\n  }\n  .leftWing {\n    width: 100%;\n  }\n  .rightWing {\n    width: 100%;\n    margin: 0.5rem 0;\n  }\n}\n", ""]);
// Exports
module.exports = exports;
